<script lang="ts" setup>
const props = withDefaults(defineProps<{
  label?: string | null
  content?: string | number | null
  contentClass?: string | null
  inline?: boolean
  ui?: { root?: string, label?: string, content?: string }
}>(), {
  ui: () => ({}),
})

const wrapperClass = computed(() => ({
  'flex gap-1 flex-wrap': true,
  'flex-row': props.inline,
  'flex-col': !props.inline,
}))
const contentClass = computed(() => ({
  'text-surface-900': true,
  [props.contentClass || '']: true,
  [props.ui.content || '']: true,
}))
</script>

<template>
  <div :class="wrapperClass">
    <div v-if="props.label || $slots.label" class="text-surface-500 flex items-center gap-2">
      <slot name="labelPrefix" />
      <slot name="label">
        <span :class="props.ui.label">{{ props.label }}</span>
      </slot>
      <slot name="labelSuffix" />
    </div>
    <div :class="contentClass">
      <slot>{{ props.content }}</slot>
    </div>
  </div>
</template>
